import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import BotErrorImage from '@/assets/bot-error-image.webp'
import BotMicrophonePermissionImage from '@/assets/bot-microphone-permission-image.webp'
import { Button, Column, Row, Text } from '@/components/core'
import AvatarCard from '@/components/layout/AvatarCard.tsx'
import { useMediaDevices } from '@/contexts/MediaDevicesContext.tsx'
import { ROUTES } from '@/types/routes.ts'

const MicrophonePermission: React.FC = () => {
  const navigate = useNavigate()
  const { hasPermission, isCheckingPermission, requestMicrophonePermission } =
    useMediaDevices()

  const [alreadyAsked, setAlreadyAsked] = useState(false)

  if (!hasPermission && !isCheckingPermission && alreadyAsked) {
    return (
      <AvatarCard variant="image" botAvatar={BotErrorImage}>
        <Column className="h-full flex-1 space-y-4">
          <Column className="flex-1 space-y-5">
            <Text.Translated
              color="600"
              className="max-sm:text-xl sm:text-2xl"
              translationKey="microphone_disabled_microphone_permission_error"
            />
            <Text.Translated
              color="600"
              className="max-sm:text-base"
              translationKey="step_one_microphone_permission_error"
            />
            <Text.Translated
              color="600"
              className="max-sm:text-base"
              translationKey="step_two_microphone_permission_error"
            />
            <Text.Translated
              color="600"
              className="max-sm:text-base"
              translationKey="step_three_microphone_permission_error"
            />
          </Column>
          <Row className="w-full self-center sm:max-w-[222px]">
            <Button.Translated
              translationKey="reload_button_setup_states_microphone_permission_error"
              grow
              onClick={() => window.location.reload()}
            />
          </Row>
        </Column>
      </AvatarCard>
    )
  }

  return (
    <AvatarCard variant="image" botAvatar={BotMicrophonePermissionImage}>
      <Column className="h-full flex-1 space-y-4">
        <Column className="flex-1 space-y-5">
          <Text
            color="600"
            align="center"
            className="max-sm:text-xl sm:text-2xl"
          >
            <Text.Translated
              translationKey="click_microphone_permission"
              color="600"
              align="center"
              className="max-sm:text-xl sm:text-2xl"
            />{' '}
            <Text.Translated
              translationKey="allow_mic_microphone_permission"
              color="600"
              fontWeight="bold"
              className="max-sm:text-xl sm:text-2xl"
            />
          </Text>
          <Text color="600" align="center" className="max-sm:text-base">
            <Text.Translated translationKey="message_one_microphone_permission" />{' '}
            <Text.Translated
              translationKey="message_two_microphone_permission"
              color="600"
              fontWeight="bold"
              className="max-sm:text-base"
            />{' '}
            <Text.Translated translationKey="message_three_microphone_permission" />{' '}
            <Text.Translated
              translationKey="message_four_microphone_permission"
              color="600"
              fontWeight="bold"
              className="max-sm:text-base"
            />{' '}
            <Text.Translated translationKey="message_five_microphone_permission" />
          </Text>
        </Column>
        <Column className="w-full justify-center self-center sm:max-w-[360px]">
          {hasPermission ? (
            <Button.Translated
              onClick={() => navigate(ROUTES.ONBOARDING.RECORDING_TEST)}
              translationKey="next_button_video_test_done"
            />
          ) : (
            <Button.Translated
              translationKey="allow_microphone_access_button_setup_states_microphone_permission"
              grow
              pending={isCheckingPermission}
              onClick={async () => {
                setAlreadyAsked(true)
                await requestMicrophonePermission()
              }}
            />
          )}
        </Column>
      </Column>
    </AvatarCard>
  )
}

export default MicrophonePermission
